import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import type { Database } from '../database.types';

export function useWorkOrderHistory(workOrderId: string) {
  const [history, setHistory] = useState<Database['public']['Tables']['work_order_status_history']['Row'][]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchHistory() {
      try {
        // First get the history records
        const { data, error: fetchError } = await supabase
          .from('work_order_status_history')
          .select('*')
          .eq('work_order_id', workOrderId)
          .order('created_at', { ascending: true });

        if (fetchError) throw fetchError;
        
        // Then get emails for each changed_by user
        const historyWithEmails = await Promise.all(
          (data || []).map(async (item) => {
            if (!item.changed_by) {
              return {
                ...item,
                changed_by: { email: 'System' }
              };
            }

            const { data: email } = await supabase
              .rpc('get_user_email', { user_id: item.changed_by });

            return {
              ...item,
              changed_by: { email: email || 'Unknown User' }
            };
          })
        );

        setHistory(historyWithEmails);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch history');
      } finally {
        setLoading(false);
      }
    }

    fetchHistory();
  }, [workOrderId]);

  return { history, loading, error };
}